import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { loginUserCheck, logoutUser, privilegeUpdateById } from '../redux/actions'

class AdminEditPrivilege extends Component {

    constructor(){
        super()
        this.state = {
            id: "",
            img: "",
            photo: "",
            title: "",
            point: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        let params = this.getParams()
        this.setState({ 
            id: params.id,
            img: params.img+"&token="+params.token,
            title: params.title,
            point: params.point
        })
    }

    getParams() {
        const str = this.props.location.search;
        let objURL = {};
        str.replace(
            new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
            ( $0, $1, $2, $3 ) => {
                objURL[ $1 ] = $3;
            }
        );
        return objURL;
    };

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }
    
    _onHandleChange(event) {
        if(event.target.files) {
            this.setState({
                [event.target.name]: event.target.files[0]
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }

    _onSubmit() {
        let oldImg = decodeURIComponent(this.state.img.substring(70,99))
        let data = {
            img: this.state.photo,
            title: this.state.title,
            point: this.state.point,
            created_by: this.props.admin
        }
        if(this.state.title && this.state.point) {
            this.props.privilegeUpdateById(this.state.id, data, oldImg)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() {
        return (
            <div>
                <Header name={this.props.admin} logout={() => this._handleLogout()} />
                <div className="admin-editprivilege">
                    <Nav active="privilege"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>สิทธิพิเศษ : แก้ไขรายการ</h2>
                            </div>
                            <div className="info">
                                <div className="adjust">
                                    <form action="" className="photo">
                                        <div className="privilege-title">
                                            <p>รูปภาพสิทธิพิเศษ (200x182px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.photo.name}</p>
                                        </div>
                                        <div className="photo-input">
                                            <input id="photo" type="file" name="photo" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="photo">เลือกรูปภาพ</label>
                                        </div>
                                        <div className="oldphoto">
                                            <img src={this.state.img} alt="privilege"/>
                                        </div>
                                    </form>
                                    <form className="text">
                                        <p>ชื่อเรื่อง</p>
                                        <input type="text" name="title" value={this.state.title} onChange={(event) => this._onHandleChange(event)}></input>
                                        <p>คะแนน</p>
                                        <input type="number" name="point" value={this.state.point} onChange={(event) => this._onHandleChange(event)}></input>
                                    </form>
                                    <div className="btn-submit">
                                        {
                                            (this.props.loading) ?
                                            <p style={{textAlign: 'center'}}>Loading...</p>
                                            : <BtnSave click={() => this._onSubmit()}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth }) => {
    return { 
        admin: auth.user,
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, privilegeUpdateById
})(AdminEditPrivilege);